import _ from 'lodash'
import { useCallback } from 'react'
import { withZero } from '../../../../../common/utils'
import { newStep } from '../../../../../common/step'

const fieldsToCopy = [
  'stepJumpStart',
  'stepJumpLength',
  'stepParameter1',
  'stepParameter2',
  'stepParameter3',
  'stepText1',
  'stepText2',
  'stepDuration1',
  'stepDuration2',
  'stepPower1',
  'stepPower2',
]

export default ({ onChange, model, field, defaultLocale, selectStep, appliance }) => {
  const handleAddStep = useCallback((type, typePath) => {
    const target = `values[${field}].${typePath}`
    const existing = _.get(model, target, [])
    const lastOne = existing.length && existing[existing.length - 1]
    onChange({
      target: {
        value: [...existing, newStep({
          defaultLocale,
          title: `Step ${withZero(existing.length + 1)}`,
          type,
          ...(type === 'cooking' ? { backgroundImage: appliance.image } : null),
          ...(type === 'cooking' && lastOne ? {
            ..._.pick(lastOne, fieldsToCopy), // copy params from previous step
          } : null),
        })],
        name: target,
      },
    }, model => {
      const index = existing.length
      // predefine errors to prevent multiple render
      if (!model.errors) {
        model.errors = {}
      }

      if (type === 'cooking') {
        model.errors[`${target}[${index}].name.${defaultLocale}`] = 'Field is required'
      }
      model.errors[`${target}[${index}].description.${defaultLocale}`] = 'Field is required'
      return model
    })
    selectStep(`${typePath}[${existing.length}]`)
  }, [appliance.image, defaultLocale, field, model, onChange, selectStep])
  return handleAddStep
}
